<div #region [attr.key]="key" [ngStyle]="{
  'background-color': background,
  'border-radius': borderRadius,
  'border' : border,
  'overflow': 'visible',
  'display': 'flex',
  'justify-content': 'center',
  'align-items': 'center'
}"
(click)="onChangeValue($event)">
<img #imageElement [src]="getUrl()" onerror="this.style.display='none'" [ngStyle]="{
  'min-width': 'fit-content',
  'min-height': 'fit-content'
}">
</div>
